// extracted by mini-css-extract-plugin
module.exports = {"slidergraph":"FacetSlider--slidergraph","handle":"FacetSlider--handle","range":"FacetSlider--range","slider":"FacetSlider--slider"};